module.exports = "<div class=\"button\" (mouseenter)=\"openDropdown()\" (mouseleave)=\"hideDropdown()\">\n  <ng-content></ng-content>\n</div>\n<div #tooltip class=\"button-tooltip\" *ngIf=\"caption\">\n  <i class=\"oi oi-caret-top\"></i>\n  {{ caption }}\n  <i class=\"oi oi-caret-bottom\"></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/tooltip-button/tooltip-button.component.html
// module id = ../../../../../src/app/shared/components/tooltip-button/tooltip-button.component.html
// module chunks = 12